import UseCredentialsLogout from 'frontcore/domain/authorization/view/UseCredentialsLogout'
import useLoginConfigurationStore from 'frontcore/domain/authorization/store/useLoginConfigurationStore'
import UseSAMLLogout from 'frontcore/domain/authorization/view/UseSAMLLogout'
import UseSSOLogout from 'frontcore/domain/authorization/view/UseSSOLogout'
import { LoginTypeOptions, LogoutEmit } from 'frontcore/domain/authorization/model/types'

const useLogout = (
  userLoginType: LoginTypeOptions,
  emit: LogoutEmit
) => {

  const { ssoConfigurationValue } = useLoginConfigurationStore()

  const useLogoutSaml = (new UseSAMLLogout(emit)).use()
  const useSSOLogout = (new UseSSOLogout()).use(ssoConfigurationValue?.redirectUri)
  const useCredentialLogout = (new UseCredentialsLogout(emit)).use()

  const logout = async () => {
    switch (userLoginType) {
    case LoginTypeOptions.SAML:
      useLogoutSaml.logout()
      break
    case LoginTypeOptions.SSO:
      await useSSOLogout.logout()
      break
    default:
      useCredentialLogout()
    }
  }

  const continueLogoutProcess = (isLoggingOut: boolean) => {
    if (userLoginType === LoginTypeOptions.SAML) {
      useLogoutSaml.continueLogoutProcess(isLoggingOut)
    }
  }

  return {
    logout,
    continueLogoutProcess,
  }
}

export default useLogout
